/**
 * **Hilfe › „Testdaten anlegen / entfernen …“** (#269): Das Menü schickt die Aktion an ein App-Fenster,
 * das fragt nach und meldet das Ergebnis als Toast.
 */
export const TESTDATA_REQUEST_CHANNEL = 'testdata:request'

export type TestDataMenuAction = 'create' | 'remove'

export interface TestDataMenuRequest {
  action: TestDataMenuAction
}
